import additional_details from "./stages/additional_details";
import company_details from "./stages/company_details";
import contact_details from "./stages/contact_details";
import membership_type from "./stages/membership_type";
import payment_details from "./stages/payment_details";
import user_details from "./stages/user_details";

/**
 * All the stages the membership form uses
 */
export const stages = {
    membership_type    : membership_type,
    user_details       : user_details,
    company_details    : company_details,
    contact_details    : contact_details,
    additional_details : additional_details,
    payment_details    : payment_details
}